import { StyleSheet } from "react-native";

import type { UiTheme } from "../theme";

// The «Save as model» dialog's two steps (ModelSaveDialog, ModelSavedView).
export function makeModelSaveStyles(theme: UiTheme) {
  const { palette: p, spacing: s, typography: ty } = theme;
  return StyleSheet.create({
    scroll: { gap: s.s3 },
    body: { color: p.ink2, fontSize: ty.sizes.sm },
    muted: { color: p.ink3, fontSize: ty.sizes.sm },
    error: { color: p.danger, fontSize: ty.sizes.sm },
    group: { gap: s.s1 },
    item: { gap: s.s1 },
    bulletRow: { flexDirection: "row", gap: s.s2 },
    flex: { flex: 1 },
    groupTitle: { color: p.ink, fontSize: ty.sizes.sm, fontWeight: "600" },
    actions: { flexDirection: "row", flexWrap: "wrap", justifyContent: "flex-end", gap: s.s3 },
    // Reading order first, look second: Plan first in the source, on the right.
    // Never wider than the dialog: a long label wraps inside its button.
    actionButton: { flexShrink: 1, maxWidth: "100%" },
    actionsReverse: { flexDirection: "row-reverse", justifyContent: "flex-start" },
  });
}

export type ModelSaveStyles = ReturnType<typeof makeModelSaveStyles>;
